module.exports = {
      id: "tag-usage",
      viewBox: "0 0 30.383 24.21",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#tag",
      toString: function () {
        return this.url;
      }
    }